// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__99evt","select":"Header_select__222lp","clinic":"Header_clinic__1kfrD"};